import {
  HomeOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { buildMenuItem } from 'config/menu-item';

export const hubItems = [
  buildMenuItem(
    'Financial Tools',
    'Health Check',
    null,
    null,
    [buildMenuItem('Survey Reports', 'survey-reports', '/hub/survey-reports')],
    'group'
  ),
];

export const investmentItems = [
  buildMenuItem('Investment', 'investment', '/investment', <HomeOutlined />),
  buildMenuItem('Orders', 'orders', '/investment/orders'),
  buildMenuItem('Fund Orders', 'order', '/investment/fund-orders'),
  buildMenuItem('Stock Orders', 'stock-orders', '/investment/stock-orders'),
  buildMenuItem(
    'Portfolios',
    'portfolio',
    '/investment/portfolios?ordering=-market_value'
  ),
  buildMenuItem(
    'Balance History',
    'balance-histories',
    '/investment/stock-balance-histories'
  ),

  buildMenuItem(
    'Account',
    'account',
    null,
    null,
    [
      buildMenuItem('User Accounts', 'user', '/investment/users'),
      buildMenuItem(
        'Fund Accounts',
        'fund-accounts',
        '/investment/fund-accounts'
      ),
      buildMenuItem(
        'Stock Accounts',
        'stock-accounts',
        '/investment/stock-accounts'
      ),
      buildMenuItem(
        'Bank Accounts',
        'bank-accounts',
        '/investment/bank-accounts'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Subscription',
    'subscription',
    null,
    null,
    [
      buildMenuItem('Plans', 'subscriptions', '/investment/subscriptions'),
      buildMenuItem(
        'IAP Notifications',
        'iap-notifications',
        '/investment/iap-notifications'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Retail',
    'retail',
    null,
    null,
    [buildMenuItem('Programs', 'user-program', '/investment/user-programs')],
    'group'
  ),
  buildMenuItem(
    'Others',
    'others',
    null,
    null,
    [
      buildMenuItem(
        'Fund Econtracts',
        'fund-econtracts',
        '/investment/fund-econtracts'
      ),
    ],
    'group'
  ),
];

export const investcoreItems = [
  buildMenuItem('Stag Admin', 'investcore', '/admin', <SettingOutlined />),
  buildMenuItem(
    'Investment Data',
    'data',
    null,
    null,
    [
      buildMenuItem('Banks', 'bank', '/admin/banks'),
      buildMenuItem('Fund Products', 'product-fund', '/admin/products/funds'),
      buildMenuItem('ETF Products', 'product-etf', '/admin/products/etfs'),
      buildMenuItem(
        'Stock Products',
        'product-stock',
        '/admin/products/stocks'
      ),
      buildMenuItem(
        'Stock Fundamentals',
        'stock-fundamentals',
        '/admin/stock-fundamentals'
      ),
      buildMenuItem(
        'Fund Distributors',
        'fund-distributors',
        '/admin/fund-distributors'
      ),

      buildMenuItem('Fund Managers', 'fund-managers', '/admin/fund-managers'),

      buildMenuItem(
        'Market Calendar',
        'market-calendar',
        '/admin/market-calendar'
      ),

      buildMenuItem('Market Index', 'market-index', '/admin/market-index'),

      buildMenuItem('Stock Events', 'stock-event', '/admin/stock-events'),
    ],
    'group'
  ),
  buildMenuItem(
    'Home Screen',
    'home-screen',
    null,
    null,
    [
      buildMenuItem('Home Widgets', 'home-widgets', '/admin/home-widgets'),
    ],
    'group'
  ),
  buildMenuItem('Stag Portfolios', 'stag-portfolios', '/admin/stag-portfolios'),
  buildMenuItem('Investment Themes', 'investment-themes', '/admin/investment-themes'),
  buildMenuItem(
    'ICB Classification',
    'stock-icb',
    null,
    null,
    [
      buildMenuItem(
        'Industries',
        'icb-industries',
        '/admin/stock-icb/industries'
      ),
      buildMenuItem(
        'SuperSectors',
        'icb-supersectors',
        '/admin/stock-icb/supersectors'
      ),
      buildMenuItem('Sectors', 'icb-sectors', '/admin/stock-icb/sectors'),
      buildMenuItem(
        'SubSectors',
        'icb-subsectors',
        '/admin/stock-icb/subsectors'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Address Data',
    'address-data',
    null,
    null,
    [
      buildMenuItem('Provinces', 'provinces', '/admin/provinces'),
      buildMenuItem('Districts', 'districts', '/admin/districts'),
      buildMenuItem('Wards', 'wards', '/admin/wards'),
    ],
    'group'
  ),

  buildMenuItem(
    'Monitoring',
    'monitoring',
    null,
    null,
    [
      buildMenuItem(
        'Notification Logs',
        'notification-logs',
        '/admin/notification-logs'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Access Control',
    'access-control',
    null,
    null,
    [
      buildMenuItem(
        'Staff Accounts',
        'staff-accounts',
        '/admin/staff-accounts'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'AI Agents',
    'ai-agents',
    null,
    null,
    [
      buildMenuItem('Stag Agent', 'agent', '/agent'),
      buildMenuItem('Agent approvals', 'agent-approvals', '/agent/approvals'),
      buildMenuItem('Agent activity', 'agent-activity', '/agent/activity'),
      buildMenuItem('Ops MCP', 'ops-mcp', '/admin/ops-mcp'),
    ],
    'group'
  ),
];

export const nhsvItems = [
  buildMenuItem('NHSV', 'nhsv', '/nhsv/home', <SettingOutlined />),
  buildMenuItem(
    'Accounts',
    'accounts',
    null,
    null,
    [
      buildMenuItem(
        'Lookup by ID',
        'nhsv-lookup-account',
        '/nhsv/lookup-account'
      ),
      buildMenuItem(
        'Account Detail',
        'nhsv-account-detail',
        '/nhsv/account-detail'
      ),
      buildMenuItem(
        'Order History',
        'nhsv-order-history',
        '/nhsv/order-history'
      ),
    ],
    'group'
  ),
  buildMenuItem(
    'Webhooks',
    'webhooks',
    null,
    null,
    [
      buildMenuItem(
        'Webhook Configs',
        'webhook-configs',
        '/nhsv/webhook-configs'
      ),
    ],
    'group'
  ),
];

export const wealthItems = [
  // Header — key = '/wealth', redirects to /wealth/programs via AppRouter
  buildMenuItem('Private Wealth', 'wealth', '/wealth', <HomeOutlined />),
  buildMenuItem(
    'Programs',
    'wealth-programs-group',
    null,
    null,
    [
      buildMenuItem('All Programs', 'wealth-programs', '/wealth/programs'),
    ],
    'group'
  ),
  buildMenuItem(
    'Access Control',
    'wealth-access-control',
    null,
    null,
    [
      buildMenuItem(
        'Wealth Assignments',
        'wealth-user-assignments',
        '/wealth/user-assignments'
      ),
    ],
    'group'
  ),
];

export const accountingItems = [
  // Header — key = '/accounting', redirects to /accounting/home via AppRouter
  buildMenuItem('Accounting', 'accounting', '/accounting', <HomeOutlined />),
  buildMenuItem(
    'Reconciliation',
    'accounting-reconciliation',
    null,
    null,
    [
      buildMenuItem(
        'Fund Reconciliation',
        'accounting-fund-reconciliation',
        '/accounting/fund-order-reconciliation'
      ),
      buildMenuItem(
        'Stock Reconciliation',
        'accounting-stock-reconciliation',
        '/accounting/stock-order-reconciliation'
      ),
    ],
    'group'
  ),
];

export const futureflexItems = [
  // Header — key = '/futureflex', redirects to /futureflex/home via AppRouter
  buildMenuItem('FutureFlex', 'futureflex', '/futureflex', <HomeOutlined />),
  buildMenuItem(
    'Programs',
    'futureflex-programs',
    null,
    null,
    [
      buildMenuItem(
        'Employee Programs',
        'employee-program',
        '/futureflex/employee-programs'
      ),
      buildMenuItem('Orders', 'program-orders', '/futureflex/program-orders'),
    ],
    'group'
  ),
  buildMenuItem(
    'Organizations',
    'futureflex-organizations',
    null,
    null,
    [
      buildMenuItem('Companies', 'company', '/futureflex/companies'),
      buildMenuItem('Employees', 'employees', '/futureflex/employees'),
      buildMenuItem('HR Admin', 'staffs', '/futureflex/staffs'),
    ],
    'group'
  ),
];

// The agent app's sidebar is the chat thread list (apps/agent/components/ThreadSidebar).
export const agentItems = [];

export const getItems = (appKey: string) => {
  if (appKey === 'hub') {
    return hubItems;
  }
  if (appKey === 'investment') {
    return investmentItems;
  }
  if (appKey === 'admin') {
    return investcoreItems;
  }
  if (appKey === 'nhsv') {
    return nhsvItems;
  }
  if (appKey === 'wealth') {
    return wealthItems;
  }
  if (appKey === 'accounting') {
    return accountingItems;
  }
  if (appKey === 'futureflex') {
    return futureflexItems;
  }
  if (appKey === 'agent') {
    return agentItems;
  }

  return [buildMenuItem('Stag Admin', 'home', '/home')];
};
